<template>
  <FilterBlock :showFilter="showFilter" :title="$t('common_filterBy.localization_value.value')" @close="closeFilter">
    <template slot="body">
      <div class="table-filter__item">
        <DefaultInput
            :label="'Order ID'"
            :type="'text'"
            v-model="id"
        />
      </div>
      <div class="table-filter__item">
        <DatePickerDefault
            :label="'Created'"
            v-model="date"
        >
          <template slot="body">
            <date-picker
                v-model="date"
                ref="datePicker"
                valueType="format"
                :lang="$store.getters.getDatePickerTranslations[$store.getters.GET_LANG]"
                :format="'MM/DD/YY'"
                :placeholder="'mm/dd/yy'"
            ></date-picker>
          </template>
        </DatePickerDefault>
      </div>
      <div class="table-filter__item">
        <DefaultInput
            :label="'Shipped'"
            :type="'text'"
            v-model="name"
        />
      </div>

      <div class="table-filter__item">
        <DefaultInput
            :label="'InboundID'"
            :type="'text'"
            v-model="total"
        />
      </div>

      <div class="table-filter__item">
        <DefaultInput
            :label="'Tracking Number'"
            :type="'text'"
            v-model="partial"
        />
      </div>

    </template>
    <template slot="footer">
      <MainButton @click.native="resetFilter" :value="$t('common_resetFilters.localization_value.value')" class="secondary wfc"/>
      <MainButton @click.native="changeFilter" :value="$t('common_applyFilters.localization_value.value')" class="wfc"/>
    </template>
  </FilterBlock>
</template>

<script>
  import FilterBlock from "../../../../../../coreComponents/FilterBlock/FilterBlock";
  import MainButton from "../../../../../../UI/buttons/MainButton/MainButton";
  import DefaultInput from "../../../../../../UI/inputs/DefaultInput/DefaultInput";
  import DatePickerDefault from "../../../../../../UI/inputs/DatePickerDefault/DatePickerDefault";
  import DatePicker from 'vue2-datepicker'
  import {filterFunc} from "../../../../../../../mixins/filterFuncMixin/filterFunc";
  // import DefaultSelect from "../../../../../../UI/selectiones/DefaultSelect/DefaultSelect";

  export default {
    name: "OtherShippersFilter",
    components: {
      FilterBlock,
      MainButton,
      DatePickerDefault,
      DatePicker,
      DefaultInput,
      // DefaultSelect,
    },

    props: [
      'showFilter',
      'filterGetParams',
    ],

    mixins: [filterFunc],

    data(){
      return {
        // date: this.filterGetParams.date ? this.generateFilterDate(this.filterGetParams.date, 'MM/DD/YY'): '',
        // name: this.filterGetParams.name ? this.filterGetParams.name : '',

        date: '',
        name: '',
        id: '',
        total: '',
        partial: '',
        transactions: '',
        yourComment: '',
        adminComment: '',

        options: [{}],
      }
    },

    watch: {
      filterGetParams(newVal) {
        // this.date = newVal.date ? this.generateFilterDate(newVal.date, 'MM/DD/YY') : ''
        this.name = newVal.name ? newVal.name : ''
      },

    },

    methods: {
      closeFilter() {
        this.$emit('close')
      },

      resetFilter() {
        let data = this.resetFilterParams(this, ['date', 'name'])

        this.$emit('changeFilter', data)
      },

      changeFilter() {
        let data = this.changeFilterParams(this, ['name',])
        data.date = this.changeDateParams(this, 'date')

        this.$emit('changeFilter', data)
      },

      changeShopTypesFilter(val) {
        this.shop = val.id
      },
    },
  }
</script>

<style scoped>

</style>
